module.exports = __webpack_public_path__ + "img/shipping.b31d0c1d.png";